/* 
* Scroll To Top button that returns up to filters form on page
*/
import React, {useState} from 'react'

const ReturnToFilters = ({ offset = 1500, scrollToTop = 650 }) =>{

  const [showScroll, setShowScroll] = useState(false)

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > offset){
      setShowScroll(true)
    } 
    if (showScroll && window.pageYOffset <= offset){
      setShowScroll(false)
    }
  }

  const scrollToFilters = () => {
    window.scrollTo({top: scrollToTop, behavior: 'smooth'});
  }

  window.addEventListener('scroll', checkScrollTop)

  return (
    <div className="fixed-action-btn"
      onClick={scrollToFilters}
      style={{
        bottom: "80px", 
        right: "24px",
        display: showScroll ? 'flex' : 'none'
      }}
    >
      <button className="btn btn-rounded btn-primary text-uppercase d-none d-sm-block">
        <i className="fa fa-caret-up"></i>&nbsp;&nbsp;Return To Filters
      </button>
    </div>
  );
}

export default ReturnToFilters;


// WEBPACK FOOTER //
// ./resources/js/components/Shared/ReturnToFilters.js